module.exports = __webpack_public_path__ + "static/media/plusSimple.1c47ec45.svg";